import { ActionFunctionArgs, redirect } from "react-router-dom";
import { TEvent, TGuest } from "services/types";
import CdtAppPublicApi from "cdt-app-public-api/dist";
import { addDays, parse } from "date-fns";
import { useGuestStore } from "store";

const EVENT_ACCESS_DAYS_LIMIT = 7;

export const eventLoader = async ({ request }: ActionFunctionArgs) => {
  const url = new URL(request.url);
  const code =
    url.searchParams.get("code") ||
    url.searchParams.get("event") ||
    localStorage.getItem("eventCode");
  const cdtAppClient = new CdtAppPublicApi();
  const { guest } = useGuestStore.getState();

  if (!code) {
    return null;
  }

  if (url.pathname === "/event-not-found") {
    return null;
  }

  if (guest && guest.eventCode !== code) {
    useGuestStore.getState().clearStore();
    localStorage.removeItem("guest-storage");
    localStorage.removeItem("feed-cache");
  }

  const event: TEvent | undefined = (await cdtAppClient.getEvent(
    code
  )) as TEvent;

  if (!event) {
    localStorage.removeItem("eventCode");
    localStorage.removeItem("guest-storage");
    localStorage.removeItem("feed-cache");
    return redirect("/event-not-found");
  }

  localStorage.setItem("eventCode", code);

   const eventDate = parse(event.date, "yyyy-MM-dd", new Date());
   const accessDateLimit = addDays(eventDate, EVENT_ACCESS_DAYS_LIMIT);
   const today = new Date();

   if (accessDateLimit < today) {
     return redirect("/event-not-found");
   }

  let bannerImage = null;

  if (event.bannerUrl) {
    await new Promise<void>((resolve, reject) => {
      const img = new Image();
      img.src = event.bannerUrl as string;
      img.onload = () => {
        bannerImage = event.bannerUrl;
        resolve();
      };
      img.onerror = reject;
    });
  }

  if (bannerImage) {
    event.bannerImage = bannerImage;
  }

  if (!guest) {
    const guestId =
      Date.now().toString(36) + Math.random().toString(36).substr(2);

    const guest = {
      id: guestId,
      eventId: event?.id as string,
      eventCode: event?.code as string,
    };

    const guestCreated = await cdtAppClient.createGuest(guest);
    useGuestStore.getState().setGuest(guestCreated as TGuest);
  }

  return event;
};
